import PropTypes from 'prop-types'
import { forwardRef, useImperativeHandle, useRef } from 'react'

import { useContainerSize } from '../hooks/use-container-size'

export const MeasuredContainer = forwardRef(
  ({ as: Component, name, children, style = {}, ...props }, ref) => {
    const innerRef = useRef(null)
    const rect = useContainerSize(innerRef.current)

    useImperativeHandle(ref, () => innerRef.current)

    const customStyle = {
      [`--${name}-width`]: `${rect.width}px`,
      [`--${name}-height`]: `${rect.height}px`,
    }

    return (
      <Component {...props} ref={innerRef} style={{ ...customStyle, ...style }}>
        {children}
      </Component>
    )
  },
)

MeasuredContainer.propTypes = {
  as: PropTypes.elementType,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  style: PropTypes.object,
}

MeasuredContainer.displayName = 'MeasuredContainer'
